<template>
  <div :class="b()" :style="styleSizeName">
    <div ref="pager" :class="b('pager')" :style="pagerStyle">
      <div :class="b('pager__text')">
        <div :style="pagerPrefixStyle" v-if="pagerPrefixUrl">
          <img :src="pagerPrefixUrl" alt style="width: 100%;" />
        </div>
        <span>{{ pagerTitle }}</span>
        <span v-if="hasPager">({{ dataChart.total }})</span>
      </div>
      <div :class="b('pager__btn')" v-if="hasPager">
        <div class="entSwiper-num">
          <span class="entcurrent">{{ page }}</span
          >/
          <span class="enttotal">{{ totalPage }}</span>
        </div>
        <div :class="b('pager__btn--pre')" :style="pagerBtnStyle" @click="pageClick('pre')"></div>
        <div :class="b('pager__btn--next')" :style="pagerBtnStyle" @click="pageClick('next')"></div>
      </div>
    </div>
    <el-row :gutter="gutter" v-if="hasData">
      <el-col :span="span" v-for="(item, index) in dataChart.data" :key="index">
        <div :class="b('item')" :style="childStyle">
          <div :class="b('item--img')" :style="imgStyle">
            <img :src="item.picture_url" alt />
          </div>
          <div :class="b('item--text')" :style="textStyle">
            <p :class="b('item--text--title')">
              <a
                v-if="hasLink"
                :style="titleStyle"
                ref="text"
                :href="linkHref(item)"
                :target="linkTarget"
                >{{ item.title }}</a
              >
              <span v-else :style="titleStyle" @click="goLink({ title: item.title })">{{
                item.title
              }}</span>
            </p>
            <div v-if="hasTag" :class="b('item--text--tags')">
              <p :style="tagStyle" v-for="tag in item.tags" :key="tag" :title="tag">{{ tag }}</p>
            </div>
            <p v-if="hasSubTitle" :class="b('item--text--subTitle')" :style="subTitleStyle">
              {{ item.description }}
            </p>
            <div v-if="hasDict" :class="b('item--text--dic')">
              <p
                v-for="dic in item.dict"
                :key="dic.key"
                :style="{ lineHeight: setPx(option.dictLineHeight) }"
              >
                <span :style="keyStyle">{{ dic.key }}</span>
                <span :style="valueStyle">{{ dic.value }}</span>
              </p>
            </div>
          </div>
          <div v-if="hasSuffix" :class="b('item--suffix')">
            <p :style="suffixLabelStyle">{{ option.suffixLabelContent }}</p>
            <p :style="suffixValueStyle">{{ item.suffix_value }}</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <template v-else>
      <avue-echart-empty />
    </template>
  </div>
</template>
<script>
import { parseUrl } from '@/utils/utils';
import init from '@/mixins/chart';
export default {
  name: 'card',
  mixins: [init],
  data() {
    return {
      page: 1
    };
  },
  props: {
    option: Object,
    component: Object
  },
  computed: {
    hasData() {
      return this.dataChart.data && this.dataChart.data.length > 0;
    },
    pagerTitle() {
      return this.option.pagerTitle;
    },
    totalPage() {
      let { total, pageTotal = 0 } = this.dataChart;
      let pageSize = this.dataQuery[this.option.pageSize] || 1;
      (total == null || total == '') && (pageTotal = 0);
      pageSize != 0 && total % pageSize == 0 && (pageTotal = parseInt(total / pageSize));
      pageSize != 0 && total % pageSize != 0 && (pageTotal = parseInt(total / pageSize) + 1);
      return pageTotal;
    },
    hasPager() {
      return this.dataChart.total;
    },
    pagerPrefixUrl() {
      return this.option.pagerPrefixUrl;
    },
    pagerPrefixStyle() {
      return {
        width: this.setPx(this.option.pagerPrefixSize),
        height: this.setPx(this.option.pagerPrefixSize),
        marginRight: this.setPx(this.option.pagerPrefixSplit)
      };
    },
    pagerStyle() {
      return {
        fontWeight: this.option.pagerFontWeight || 'normal',
        fontSize: this.setPx(this.option.pagerFontSize),
        color: this.option.pagerColor || '#fff',
        marginBottom: this.setPx(this.option.pagerSplit)
      };
    },
    pagerBtnStyle() {
      return {
        width: this.setPx(this.option.pagerBtnSize),
        height: this.setPx(this.option.pagerBtnSize),
        background: this.option.pagerBtnBgc || '#3563aa'
      };
    },
    gutter() {
      return this.option.cardGutter;
    },
    span() {
      return 24 / this.option.cardSpan;
    },
    hasTag() {
      return this.option.hasTag;
    },
    hasSubTitle() {
      return this.option.hasSubTitle;
    },
    hasDict() {
      return this.option.hasDict;
    },
    hasSuffix() {
      return this.option.hasSuffix;
    },
    hasLink() {
      return this.option.hasLink;
    },
    linkTarget() {
      return this.option.linkTarget || '_blank';
    },
    childStyle() {
      return {
        height:
          this.option.cardMode === 'horizontal'
            ? this.setPx(
                (this.component.height - this.$refs.pager.offsetHeight - this.option.pagerSplit) /
                  this.dataChart.data.length
              )
            : this.setPx(
                this.component.height - this.$refs.pager.offsetHeight - this.option.pagerSplit
              ),
        padding: this.setPx(this.option.cardPadding || 0),
        border: `${this.option.cardBorderWidth || 1}px solid ${this.option.cardBorderColor ||
          '#055e96'}`,
        background: this.option.cardBgc || 'rgba(13, 42, 86, 0.44)',
        marginBottom: this.setPx(this.option.cardGutter || 10),
        alignItems: this.option.cardMode === 'horizontal' ? 'center' : 'flex-start',
        flexDirection: this.option.cardMode === 'horizontal' ? 'row' : 'column'
      };
    },
    imgStyle() {
      return {
        height:
          this.option.cardMode === 'horizontal' ? '100%' : this.setPx(this.option.imgSize || 100),
        width:
          this.option.cardMode === 'horizontal' ? this.setPx(this.option.imgSize || 100) : '100%'
      };
    },
    textStyle() {
      return {
        padding: this.setPx(this.option.textPadding || 12),
        boxSizing: 'border-box'
      };
    },
    titleStyle() {
      return {
        color: this.option.titleColor,
        fontSize: this.setPx(this.option.titleSize),
        fontWeight: this.option.titleWeight,
        lineHeight: this.setPx(this.option.titleLineHeight || 16)
      };
    },
    subTitleStyle() {
      return {
        color: this.option.subTitleColor,
        fontSize: this.setPx(this.option.subTitleSize),
        lineHeight: this.setPx(this.option.subTitleLineHeight || 16)
      };
    },
    tagStyle() {
      return {
        color: this.option.tagColor,
        fontSize: this.setPx(this.option.tagSize),
        lineHeight: this.setPx(this.option.tagLineHeight || 16),
        background: this.option.tagBgc || 'rgba(13, 42, 86, 0.44)',
        borderRadius: this.setPx(this.option.tagRadius),
        marginRight: this.setPx(this.option.splitx),
        marginBottom: this.setPx(this.option.splity)
      };
    },
    keyStyle() {
      return {
        color: this.option.keyColor,
        fontSize: this.setPx(this.option.keySize),
        fontWeight: this.option.keyWeight,
        marginRight: this.setPx(this.option.keySplit),
        verticalAlign: 'middle'
      };
    },
    valueStyle() {
      return {
        color: this.option.valueColor,
        fontSize: this.setPx(this.option.valueSize),
        fontWeight: this.option.valueWeight,
        verticalAlign: 'middle'
      };
    },
    suffixLabelStyle() {
      return {
        color: this.option.suffixLabelColor,
        fontSize: this.setPx(this.option.suffixLabelSize),
        fontWeight: this.option.suffixLabelWeight,
        lineHeight: this.setPx(this.option.suffixLabelLineHeight)
      };
    },
    suffixValueStyle() {
      return {
        color: this.option.suffixValueColor,
        fontSize: this.setPx(this.option.suffixValueSize),
        fontWeight: this.option.suffixValueWeight,
        lineHeight: this.setPx(this.option.suffixValueLineHeight)
      };
    }
  },
  methods: {
    goLink(obj) {
      this.progressClick(obj);
    },
    pageClick(type) {
      if (type === 'pre') {
        if (this.page > 1) {
          this.page--;
          this.click({
            type: 'tabs',
            child: {
              paramName: this.option.currentPPage,
              index: [this.$attrs.index]
            },
            value: this.page
          });
        }
      } else {
        if (this.page < this.totalPage) {
          this.page++;
          this.click({
            type: 'tabs',
            child: {
              paramName: this.option.currentPPage,
              index: [this.$attrs.index]
            },
            value: this.page
          });
        }
      }
    },
    linkHref(item) {
      let { linkHref = '#' } = this.option;
      linkHref = parseUrl(linkHref, item);
      return linkHref;
    }
  }
};
</script>

<style lang="scss" scoped>
.avue-echart-card {
  &__pager {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: none;
    &__text {
      display: flex;
    }
    &__btn {
      position: relative;
      min-width: 100px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      &--pre,
      &--next {
        outline: none;
        width: 22px;
        height: 22px;
        border-radius: 2px;
        background: #3563aa;
        text-align: center;
        line-height: 22px;
        top: 0;
        margin: 0 5px;
        position: relative;
        cursor: pointer;
        &::after {
          content: '';
          font-size: 10px;
          width: 0;
          height: 0;
          border-top: 0.8em solid transparent;
          border-bottom: 0.8em solid transparent;
          position: absolute;
          top: 50%;
          left: 50%;
        }
      }
      &--pre {
        &::after {
          content: '';
          border-right: 0.8em solid #fff;
          border-left: 0.8em solid transparent;
          transform: translate(-75%, -50%);
        }
      }
      &--next {
        &::after {
          content: '';
          border-left: 0.8em solid #fff;
          border-right: 0.8em solid transparent;
          transform: translate(-25%, -50%);
        }
      }
    }
  }

  &__item {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    box-sizing: border-box;
    &--img {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      overflow: hidden;
      img {
        width: 100%;
        transition: all ease 1s;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    &--text {
      flex-grow: 1;
      &--title,
      &--subTitle {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &--tags {
        display: flex;
        // flex-wrap: wrap;
        p {
          padding: 0px 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
